import ProjectCard from './Components/ProjectCard';

const DesktopLayout = ({ projects, itemSelected, setItemSelected }) => {
  return (
    <>
      {projects.map((project, idx) => (
        <ProjectCard
          key={project.title}
          project={project}
          index={idx}
          itemSelected={itemSelected}
          setItemSelected={setItemSelected}
        />
      ))}
    </>
  );
};

export default DesktopLayout;
